<template>
  <div class="antialiased text-gray-800 bg-gray-200 flex flex-col min-h-screen">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppHolder'
}
</script>

<style>
  /* purgecss start ignore */
  @tailwind  base;
  @tailwind  components;
  /* purgecss end ignore */

  @tailwind utilities;
</style>
